const roles = {
  admin: "admin",
  edit: "edit",
  editJs: "editJs",
  editAlias: "editAlias",
  view: "view"
};

const scriptEditorRights = [
  {
    name: "unauthorized",
    description: "No access",
    value: 0,
    roles: []
  },
  {
    name: "view",
    description: "View and comment",
    value: 1,
    roles: [roles.view]
  },
  {
    name: "edit",
    description: "Edit Script metadata",
    value: 2,
    roles: [roles.edit, roles.view]
  },
  {
    name: "editJs",
    description: "Edit Script code",
    value: 3,
    roles: [roles.editJs, roles.edit, roles.view]
  },
  {
    name: "editAlias",
    description: "Edit aliases and codes",
    value: 35,
    roles: [roles.editAlias, roles.editJs, roles.edit, roles.view]
  },
  {
    name: "admin",
    description: "Full rights",
    value: 4,
    roles: [roles.admin, roles.editAlias, roles.editJs, roles.edit, roles.view]
  }
];

const appRights = {
  noAccess: {
    description: "No Access",
    value: 0
  },
  view: {
    description: "View",
    value: 1
  },
  edit: {
    description: "Edit",
    value: 2
  },
  full: {
    description: "Full rights",
    value: 3
  }
};

/*
 * Documentation of right levels and descriptions for different applications:
 * https://www.notion.so/ebmeds/04b9d55f5db24954825d03c3a36e01ee?v=76078eb70fdd4c828d72c843fcf62a4f
 */
const applicationRights = {
  Deo: [appRights.noAccess, appRights.edit],
  EDDM: [appRights.noAccess, appRights.edit],
  Editor: scriptEditorRights,
  Feedback: [appRights.noAccess, { ...appRights.edit, value: 1 }],
  Form: [
    appRights.noAccess,
    appRights.view,
    { ...appRights.edit, description: "Edit (organization)" },
    appRights.full
  ],
  Publisher: [appRights.noAccess, appRights.edit],
  Takku: [
    appRights.noAccess,
    { ...appRights.edit, value: 1 },
    { ...appRights.full, value: 2 }
  ],
  Tester: [appRights.noAccess, appRights.view]
};

const applications = Object.keys(applicationRights);

const getRolesByDatabaseRightLevel = rightLevel => {
  const rightsByLevel = scriptEditorRights.find(r => r.value === rightLevel);

  return (rightsByLevel && rightsByLevel.roles) || [];
};

module.exports = {
  applications,
  getRolesByDatabaseRightLevel,
  applicationRights,
  roles
};
